import React, { useEffect, useState } from 'react';
import TableComponent from '../../components/TableComponent/TableComponent';

const JuzBreakdown = () => {
    const [sajdahPlaces, setSajdahPlaces] = useState([]);
    useEffect(() => {
        fetch('/assets/json/juzBreakdown.json')
            .then(response => response.json())
            .then(data => {
                setSajdahPlaces([...data]);
            });
    }, []);
    return (
        <div className="mt-5 mb-5">
            <div className="container">
                <TableComponent
                    data={sajdahPlaces}
                    heading={["Juz No.", "Juz Name", "Starts", "Ends"]}
                    keyInfo={["Juz No.", "Juz Name", "Starts", "Ends"]}
                />
            </div>
        </div>
    );
};

export default JuzBreakdown;